<template>
  <section class="document-form sme-container__info sme-container__info-document">
    <div class="box">
      <div class="table">
        <div class="th font-14" >Documents</div>
        <div class="form-item tr">
          <span>Business Registration Certificate</span>
          <file-container
            is-show-detail
            is-viewer
            :fileData="br_files" />
        </div>
        <div
          v-if="mpf_files.length > 0"
          class="form-item tr">
          <span>Latest 3 months Contribution Record</span>
          <div>
            <file-container
              v-for="(item, index) in mpf_files"
              :key="index"
              is-show-detail
              is-viewer
              :fileData="item"
            />
          </div>
        </div>
        <div
          v-if="renewal_files.length > 0"
          class="form-item tr">
          <span>Renewal Notice / Existing Policy (Optional)</span>
          <div>
            <file-container
              v-for="(item, index) in renewal_files"
              :key="index"
              is-show-detail
              is-viewer
              :fileData="item"
            />
          </div>
        </div>
        <div
          v-if="device_files.length > 0"
          class="form-item tr">
          <div> List of  machines / devices to be insured (valued over HK$100,000 per item/set)</div>
          <div>
            <file-container
              v-for="(item, index) in device_files"
              :key="index"
              is-show-detail
              is-viewer
              :fileData="item"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'SMEDocumentInfo',
  props: {
    formData: {
      type: Object,
      default: () => ({})
    }
  },
  computed:{
    upload_document(){
      let {upload_document}  = this.formData||{}
      return upload_document
    },
    br_files(){
      let {br_files=[]} = this.upload_document||{}
      return br_files.length>0?br_files[0]:{}
    },
    device_files(){
      let {device_files=[]} = this.upload_document||{}
      return device_files
    },
    renewal_files(){
      let {renewal_files=[]} = this.upload_document||{}
      return renewal_files
    },
    mpf_files(){
      let {mpf_files=[]} = this.upload_document||{}
      return mpf_files
    },
  }
}
</script>
<style lang="scss" scoped>
@import "../../../quoting/sme/info";
.document-table{
  .tr:last-child{
    border-bottom-left-radius: 0px!important;
    border-bottom-right-radius: 0px!important;
  }
}

</style>
